export default __webpack_public_path__ + "static/thermopompe-118bfa5661b5bc00d1ad9ca599b7f77a.jpg";